import React, { useState, useEffect, useRef, useCallback } from "react";
import Pagination from "react-js-pagination";
import ConfigDB from "../../config";
import { toast } from "react-toastify";
import Utils from "../../utils";
import {
  DeleteVehicleProcess,
  exportVehicleList,
  getVehicleAllProcessList,
  getVehiclePartList,
  getVehicleSentToWastage,
  printVehicleQr,
  restoreVehicleProcess,
} from "../../services/VehicleService";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import Barcode from "react-barcode";
import DesmeImage from "../../asset/images/dismantle_icon.svg";
import { getLerCodeList } from "../../services/DepollutionService";
import Select from "react-select";
import moment from "moment";
import Dropdown from "react-bootstrap/Dropdown";
import {
  getCommonSearchList,
  getSettingsCompanyDetails,
} from "../../services/settingsServices";
import {
  getCatalogList,
  getHistoryLogList,
  partInvenoryPartPdf,
} from "../../services/PartsInventory";
import { useTranslation } from "react-i18next";
import { tConst, tConstStatic } from "../../utils/constantsTranslator";
import ReactPaginate from "react-paginate";
import * as XLSX from "xlsx";
import { debounce } from "../../utils/debounce";
import MessageCell from "../../components/MessageCell";

const vehicleDeletedList = [
  { id: 0, valueKey: "stock_management_status" },
  { id: 1, valueKey: "deleted_records" },
];

const VehicleProcess = () => {
  const tableLengthList = ConfigDB.data.dataTableLength;
  const data = localStorage.getItem(ConfigDB.data.login_data);
  const companyId = JSON.parse(data);
  const navigate = useNavigate();
  const location = useLocation();
  const RolePermission = Utils.getRecordForCurrentPath(location);
  const { t } = useTranslation();
  const [settingCompanyDetails, setSettingCompanyDetails] = useState("");
  const [params, setParams] = useState({
    limit: settingCompanyDetails?.no_of_vehicles_per_page ?? tableLengthList[0],

    page: 1,
    search: "",
    is_reload: false,
    company_id: companyId.company_id || 0,
    registration_plate: "",
    vehicle_make: "",
    vehicle_internl_ref: "",
    inventory_status: 0,
    dismental_status: 0,
    deplllution_status: 0,
    internal_id: "",
    state_parking: "",
    record_show_type: 0,
    part_check_status: 0,
    is_part_converted: 0,
    part_catalog_id: "",
    vehicle_status_filter: settingCompanyDetails?.vehicle_status_filter,
  });
  const [totalRecords, setTotalRecords] = useState(0);
  const [vehicleProcessList, setVehicleProcessList] = useState([]);
  const [registration, setRegistration] = useState("");
  const [model, setModel] = useState("");
  const [year, SetYear] = useState("");
  const [variant, SetVariant] = useState("");
  const [make, SetMake] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [registrationPlate, setRegistrationPlate] = useState("");
  const [vehicleMake, SetVehicleMake] = useState("");

  const [qrDetails, setQrDetails] = useState(false);
  const [DelPartQRId, setDelPartQRId] = useState("");
  const [vehiclePartDetails, setVehiclePartDetails] = useState([]);
  const [vehiclePartDetailsId, setVehiclePartDetailsId] = useState("");
  const [vehiclePartDetailsModal, setVehiclePartDetailsModal] = useState(false);
  const [sentWasteModal, setsentWasteModal] = useState(false);

  const [addedParts, setAddedParts] = useState([]);

  const [LerCatalogList, setLerCatalogList] = useState([]);

  const [inputValueLer, setInputValueLer] = useState("");

  const [vehiclePartsData, setVehiclePartsData] = useState({
    ler_code_id: [],
    unit_value: [],
  });

  const [show, setShow] = useState(false);
  const [partInventoryList, setPartInventoryList] = useState([]);
  const [dismentalList, setDismentalList] = useState([]);
  const [depollutionList, setDepollutionList] = useState([]);
  const [partInventoryFilter, setpartInventoryFilter] = useState(0);
  const [dismentalFilter, setDismentalFilter] = useState(0);
  const [depollutionFilter, setdepollutionFilter] = useState(0);
  const [stateParkingFilter, setStateParkingFilter] = useState(0);
  const [partCheckStatusFilter, setPartCheckStatusFilter] = useState(0);
  const [convertedStatusFilter, setConvertedStatusFilter] = useState(0);
  const [PartCatalogFilter, setPartCatalogFilter] = useState({
    catalog_name: "",
  });
  const [catelogList, setCatelogList] = useState([]);
  const [partCheckStatusList, setPartCheckStatusList] = useState([]);
  const [convertedStatusList, setConvertedStatusList] = useState([]);
  const [vehicleMakeId, setVehicleMakeId] = useState("");
  const [pdfGenerateId, setPdfGenerateId] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [partCatalogData, setPartCatalogData] = useState({
    ler_codes_id: "",
  });
  const [internalId, SetInternalId] = useState("");
  const [stateParkingList, setStateParkingList] = useState([]);
  const [delModal, setDelModal] = useState(false);
  const [delPartId, setDelPartId] = useState("");
  const [isDelButtonLoad, setIsDelButtonLoad] = useState(false);
  const [recordStatus, setRecordStatus] = useState(0);
  const [inputSelectedCatelog, setInputSelectedCatelog] = useState("");
  const [freeSearch, setFreeSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [activeHistoryTab, setActiveHistoryTab] = useState("qty"); // qty | inventory
  const [totalPartInven, setTotalPartInven] = useState(0);
  const [partPage, setPartPage] = useState(1); // current page
  const [partLimit] = useState(50); // items per page
  const [partInventoryHistoryList, setPartInventoryHistoryList] = useState([]);
  const [partHistoryQtyModal, setPartHistoryQtyModal] = useState(false);
  const [partHistoryQtyId, setpartHistoryQtyId] = useState("");

  const columnNames =
    settingCompanyDetails?.vehicle_display_columns?.columnsNames?.split(",");
  const columnKeys = settingCompanyDetails?.vehicle_display_columns?.columns;

  const sumWastageValue = vehiclePartsData.unit_value.reduce((acc, curr) => {
    const num = parseFloat(curr); // Use parseFloat to handle decimals
    return !isNaN(num) ? acc + num : acc;
  }, 0);

  const onDeleteModalOpen = (e, item) => {
    e.preventDefault();
    setDelPartId(item);
    setDelModal(true);
  };

  const onDeleteModalClose = () => {
    setDelModal(false);
  };

  const handleShowOpen = () => {
    setShow(true);
  };

  const handleShowClose = () => {
    setShow(false);
  };

  const generatePDF = (e, item) => {
    setPdfGenerateId(item.id);
  };

  const ontpartHistoryQtyDetailsOpen = (e, item) => {
    e.preventDefault();
    setpartHistoryQtyId(item.id);
    setPartHistoryQtyModal(true);
  };

  const onpartHistoryQtyDetailsClose = () => {
    setPartHistoryQtyModal(false);
  };

  useEffect(
    function () {
      if (partHistoryQtyId) {
        let data = {
          id: partHistoryQtyId,
          module_type: 2,
          limit: 50,
          page: partPage,
          search: "",
        };
        getHistoryLogList(data)
          .then((response) => {
            setPartInventoryHistoryList(response.data.data);
            setTotalPartInven(response.data.total);
          })
          .catch((err) => {});
      }
    },
    [partHistoryQtyId, partPage],
  );

  useEffect(() => {
    if (settingCompanyDetails) {
      setParams((prev) => ({
        ...prev,
        limit:
          settingCompanyDetails.no_of_vehicles_per_page || tableLengthList[0],
        vehicle_status_filter: settingCompanyDetails.vehicle_status_filter,
      }));
    }
  }, [settingCompanyDetails]);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const companyResponse = await getSettingsCompanyDetails();
        setSettingCompanyDetails(companyResponse.data.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchSettings();
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "state_parking",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setStateParkingList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    if (pdfGenerateId) {
      let data = {
        vehicle_id: pdfGenerateId,
      };

      partInvenoryPartPdf(data)
        .then((response) => {
          if (
            response.data &&
            response.data.record &&
            response.data.record.url &&
            response.status === 200
          ) {
            window.open(response.data.record.url, "_blank");
          } else {
            toast.error(response.data.message);
          }
          setTotalRecords(response.data);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [pdfGenerateId]);

  const handleAddClick = (id, registration, vehicle_model, vehicle_year) => {
    const isAdded = addedParts.some((part) => part.id === id);

    if (isAdded) {
      setAddedParts((prev) => prev.filter((part) => part.id !== id));
    } else {
      setAddedParts((prev) => [
        ...prev,
        { id, registration, vehicle_model, vehicle_year },
      ]);
    }
  };

  const filteredPartAssignList = vehicleProcessList.filter(
    (item) =>
      !addedParts.some((addedPart) => addedPart.id === item.id) &&
      (item?.registration?.toLowerCase().includes(searchQuery?.toLowerCase()) ||
        item?.vehicle_model
          ?.toLowerCase()
          .includes(searchQuery?.toLowerCase()) ||
        item?.vehicle_year?.toString().includes(searchQuery)),
  );

  const sentWasteOpenDetail = () => {
    setsentWasteModal(true);
  };

  const sentWasteCloseDetail = () => {
    setsentWasteModal(false);
  };

  const onvehiclePartDetailsClose = () => {
    setVehiclePartDetailsModal(false);
  };

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "inventory",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setPartInventoryList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "dismental",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setDismentalList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 10,
      page: 1,
      search: "",
      is_reload: true,
    };
    getCatalogList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].namePartPT,
          });
        }

        setCatelogList(list);
      })
      .catch((err) => {});
  }, []);

  const handleInputSelectedChangeCatelogList = (inputValue) => {
    setInputSelectedCatelog(inputValue);

    const obj = {
      search: inputValue,
      limit: tableLengthList[0],
      page: 1,
    };

    getCatalogList(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].namePartPT,
          });
        }

        setCatelogList(list);
      })
      .catch((err) => {});
  };

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "parts_check_status",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setPartCheckStatusList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "parts_check_converted_status",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setConvertedStatusList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "depollution",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setDepollutionList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    var obj = {
      search: "",
      limit: tableLengthList[0],
      page: 1,
    };
    getLerCodeList(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].ler_code,
            unit_value: response.data[i].unit_value || 0,
          });
        }
        setLerCatalogList(list);
      })
      .catch((err) => {});
  }, []);

  const handleInputChangeLER = (inputValueLer) => {
    setInputValueLer(inputValueLer);

    if (inputValueLer.length > 2) {
      const obj = {
        search: inputValueLer,
        limit: tableLengthList[0],
        page: 1,
      };

      getLerCodeList(obj)
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].id,
              label: response.data[i].ler_code,
              unit_value: response.data[i].unit_value || 0,
            });
          }
          setLerCatalogList(list);
        })
        .catch((err) => {});
    } else {
      setLerCatalogList([]);
      const obj = {
        search: "",
        limit: tableLengthList[0],
        page: 1,
      };

      getLerCodeList(obj)
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].id,
              label: response.data[i].ler_code,
              unit_value: response.data[i].unit_value || 0,
            });
          }
          setLerCatalogList(list);
        })
        .catch((err) => {});
    }
  };

  const handleSelectLERChange = (selectedOptions) => {
    const selectedValues = selectedOptions?.map((option) => option.value) || [];
    const unitValues =
      selectedOptions?.map((option) => option.unit_value || 0) || [];

    setVehiclePartsData((prevData) => ({
      ...prevData,
      ler_code_id: selectedValues, // Update selected IDs
      unit_value: unitValues, // Update unit values
    }));

    setPartCatalogData((prevData) => ({
      ...prevData,
      ler_codes_id: selectedOptions, // Update selected IDs
    }));
  };

  useEffect(() => {
    if (vehiclePartDetailsId) {
      let data = {
        vehicle_id: vehiclePartDetailsId,
      };

      getVehiclePartList(data)
        .then((response) => {
          setVehiclePartDetails(response.data.data);
          setTotalRecords(response.data);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [vehiclePartDetailsId]);

  useEffect(() => {
    const currentPath = location.pathname;
    const savedPath = localStorage.getItem("lastVisitedPath");

    if (savedPath && savedPath !== currentPath) {
      localStorage.removeItem("lastVisitedPage");
      localStorage.removeItem("filterData");
    }

    localStorage.setItem("lastVisitedPath", currentPath);

    const savedPage = localStorage.getItem("lastVisitedPage");
    if (savedPage) {
      setParams((prevParams) => ({
        ...prevParams,
        page: parseInt(savedPage, 10),
      }));
    }
  }, []);

  const handleParams = (e, type) => {
    let paramsObj = { ...params };
    if (type === "length") {
      paramsObj.limit = e.target.value;
    } else if (type === "search") {
      paramsObj.page = 1;
      paramsObj.search = e.target.value;
    } else if (type === "pagination") {
      paramsObj.page = e.selected + 1; // ReactPaginate starts from 0, so we add 1
      localStorage.setItem("lastVisitedPage", e.selected + 1); // Save the selected page to localStorage
    }
    paramsObj.vehicle_model = model;
    paramsObj.vehicle_year = year;
    paramsObj.registration = registration;
    paramsObj.registration_plate = registrationPlate;
    paramsObj.vehicle_make = vehicleMake;
    paramsObj.inventory_status = parseInt(partInventoryFilter);
    paramsObj.deplllution_status = parseInt(depollutionFilter);
    paramsObj.dismental_status = parseInt(dismentalFilter);
    paramsObj.vehicle_make = make;
    paramsObj.vehicle_variant = variant;
    paramsObj.internal_id = internalId;
    paramsObj.state_parking = stateParkingFilter;
    paramsObj.record_show_type = parseInt(recordStatus);
    paramsObj.part_check_status = parseInt(partCheckStatusFilter);
    paramsObj.is_part_converted = parseInt(convertedStatusFilter);
    paramsObj.part_catalog_id = parseInt(PartCatalogFilter?.catalog_name);
    paramsObj.vehicle_status_filter =
      settingCompanyDetails?.vehicle_status_filter;
    localStorage.setItem("filterData", JSON.stringify(paramsObj));
    setParams(paramsObj);
    setShow(false);
  };

  useEffect(() => {
    // Load filter data from local storage if available
    const savedFilterData = localStorage.getItem("filterData");
    if (savedFilterData) {
      const parsedFilterData = JSON.parse(savedFilterData);

      setParams(parsedFilterData);
    }
  }, []);

  useEffect(() => {
    const savedData = JSON.parse(localStorage.getItem("filterData"));
    if (savedData) {
      setpartInventoryFilter(savedData?.inventory_status);
      setDismentalFilter(savedData?.dismental_status);
      setdepollutionFilter(savedData?.deplllution_status);
      setStateParkingFilter(savedData?.state_parking);
      setVehicleMakeId(savedData?.vehicle_make);
      SetInternalId(savedData?.internal_id);
      setModel(savedData?.vehicle_model);
      SetYear(savedData?.vehicle_year);
      SetMake(savedData?.vehicle_make);
      SetVariant(savedData?.vehicle_variant);
      setRegistrationPlate(savedData?.registration_plate);
      SetVehicleMake(savedData?.vehicle_make);
    }
  }, []);

  const ResetModal = () => {
    setParams({
      limit: tableLengthList[0],
      page: 1,
      search: "",
      is_reload: false,
      company_id: companyId.company_id || 0,
      registration_plate: "",
      vehicle_make: "",
      vehicle_internl_ref: "",
      inventory_status: 0,
      dismental_status: 0,
      deplllution_status: 0,
      internal_id: "",
      state_parking: "",
      record_show_type: 0,
      part_check_status: 0,
      is_part_converted: 0,
      part_catalog_id: "",
      vehicle_status_filter: settingCompanyDetails?.vehicle_status_filter,
    });
    setModel("");
    SetYear("");
    SetMake("");
    SetVariant("");
    setRegistrationPlate("");
    SetVehicleMake("");
    setShow(false);
    setpartInventoryFilter("");
    setDismentalFilter(0);
    setdepollutionFilter(0);
    setStateParkingFilter(0);
    setVehicleMakeId("");
    SetInternalId("");
    setRecordStatus(0);
    setConvertedStatusFilter(0);
    setPartCheckStatusFilter(0);
    setPartCatalogFilter({
      catalog_name: "",
    });
    setInputSelectedCatelog("");
    localStorage.removeItem("filterData");
  };

  const handleQrDetailsClose = () => {
    setQrDetails(false);
  };

  const handleQrDetailsPrint = () => {
    let data = {
      uuid: DelPartQRId.uuid,
      vehicle_internal_id: DelPartQRId.vehicle_internal_id,
    };
    setIsLoading(true);
    printVehicleQr(data)
      .then((response) => {
        setQrDetails(false);
        setIsLoading(false);
        toast.success(response.data.message);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        setIsLoading(false);
      });
  };

  const onQrDetailsOpen = (e, item) => {
    e.preventDefault();
    setDelPartQRId(item);
    setQrDetails(true);
  };

  const fetchAllVehicleList = (fetchParams, free_search = "") => {
    let data = {
      ...fetchParams,
      free_search,
    };
    setIsLoading(true);
    getVehicleAllProcessList(data)
      .then((response) => {
        setVehicleProcessList(response.data.data);
        setTotalRecords(response.data.total);
        setIsLoading(false);
        localStorage.removeItem("vehicleId");
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchAllVehicleList(params, freeSearch);
  }, [params, freeSearch]);

  const debouncedFetch = useCallback(
    debounce((searchText) => {
      if (searchText.length > 2) {
        // Call API with search text
        fetchAllVehicleList(params, searchText);
      } else {
        // Reset API if search text is 2 characters or less
        fetchAllVehicleList(params, searchText);
      }
    }, 400), // 400ms debounce
    [params],
  );

  const onDestroyPartInventory = (e) => {
    e.preventDefault();
    setIsDelButtonLoad(true);
    let data = { id: delPartId.id };

    if (params.record_show_type === 1) {
      let UpdateData = {
        id: delPartId.id,
      };

      restoreVehicleProcess(UpdateData)
        .then((response) => {
          let data = { ...params };
          fetchAllVehicleList(data);
          toast.success(response.data.message);
          setDelPartId("");
          setDelModal(false);
          setIsDelButtonLoad(false);
        })
        .catch((err) => {
          setIsDelButtonLoad(false);
          toast.error(Utils.getErrorMessage(err));
        });
    } else {
      DeleteVehicleProcess(data)
        .then((response) => {
          let data = { ...params };
          fetchAllVehicleList(data);
          toast.success(response.data.message);
          setDelPartId("");
          setDelModal(false);
          setIsDelButtonLoad(false);
        })
        .catch((err) => {
          setIsDelButtonLoad(false);
          toast.error(Utils.getErrorMessage(err));
        });
    }
  };

  const handleVehicle = () => {
    localStorage.removeItem("ownerList");
    localStorage.removeItem("vehicleId");

    navigate("/vehicle");
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);

    const vehicle_ids = addedParts?.map((item) => item.id);
    const ler_code_id = partCatalogData?.ler_codes_id?.map((item) => ({
      id: item.value,
      unit_value: item?.unit_value || "",
    }));

    const payload = {
      vehicle_ids: vehicle_ids,
      ler_code_id: ler_code_id,
      wastege_value: sumWastageValue,
      description: "",
    };

    getVehicleSentToWastage(payload)
      .then((response) => {
        toast.dismiss();
        toast.success(response.data.message);
        setsentWasteModal(false);
      })
      .catch((err) => {
        toast.dismiss();
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const featchVehicleList = () => {
    setLoading(true);
    let data = { ...params };

    exportVehicleList(data)
      .then((response) => {
        const worksheet = XLSX.utils.json_to_sheet(response.data.data);
        const csv = XLSX.utils.sheet_to_csv(worksheet);

        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "vehicleList.csv");
        link.style.visibility = "hidden";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleExport = () => {
    featchVehicleList();
  };
  const getFuelName = (fuelId) => {
    const fuelMap = {
      1: "Petrol",
      2: "Diesel",
      3: "Electric",
      4: "Hybrid",
      18: "Gas",
    };

    return fuelMap[fuelId] || "-";
  };

  const getColumnValue = (item, key) => {
    switch (key) {
      case "vehicle_make":
        return item.vehicle_brand || "-";

      case "vehicle_model":
        return item.vehicle_model || "-";

      case "vehicle_variant":
        return item.vehicle_variant_name || "-";

      case "vehicle_year":
        return item.vehicle_year_id || "-";

      case "registration_plate":
        return item.registration_plate || "-";

      case "vehicle_fuel":
        return getFuelName(item.vehicle_fuel);

      case "steering_wheel_side":
        return item.steering_wheel_side === 1 ? "Left" : "Right";

      case "inventory_status":
        return item.inventory_status === 1
          ? tConst("In Stock", t)
          : tConst("Out of Stock", t);

      case "vehicle_type":
        return item.vehicle_type_name || "-";
      case "vehicle_process_end_date":
        return item.vehicle_process_end_date
          ? moment(item.vehicle_process_end_date).format("DD-MM-YYYY")
          : "-";

      case "vehicle_process_start_date":
        return item.vehicle_process_start_date
          ? moment(item.vehicle_process_start_date).format("DD-MM-YYYY")
          : "-";

      case "neutralization_date":
        return item.neutralization_date
          ? moment(item.neutralization_date).format("DD-MM-YYYY")
          : "-";

      case "sented_to_waste_date":
        return item.sented_to_waste_date
          ? moment(item.sented_to_waste_date).format("DD-MM-YYYY")
          : "-";

      case "vehicle_arrival_date":
        return item.vehicle_arrival_date
          ? moment(item.vehicle_arrival_date).format("DD-MM-YYYY")
          : "-";

      case "decontamination_date":
        return item.decontamination_date
          ? moment(item.decontamination_date).format("DD-MM-YYYY")
          : "-";

      default:
        return item[key] ?? "-";
    }
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">{/* <h1>Vehicle</h1> */}</div>
              <div className="col-sm-6"></div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="container-fluid container-custom-height-new">
            <div className="row">
              <div className="col-md-12">
                <div className="card fuelCard">
                  <div className="card-header">
                    <div
                      className="card-title m-0 float-left fuelCT"
                      style={{ width: "60%" }}
                    >
                      <input
                        className="form-control"
                        type="text"
                        value={freeSearch}
                        onChange={(e) => {
                          setFreeSearch(e.target.value);
                          debouncedFetch(e.target.value); //  debounce call
                        }}
                        placeholder={t("search_vehicle_refs_placeholder")}
                      />
                    </div>

                    {show && (
                      <div
                        className="offcanvas-backdrop show"
                        onClick={(e) => e.stopPropagation()}
                      ></div>
                    )}

                    <div className="card-title m-0 float-right rightBtn">
                      <div className="card-title-row">
                        <button
                          type="button"
                          className="btn btn-icon-text mr-2"
                          onClick={handleExport}
                          disabled={loading}
                        >
                          <i className="bi bi-file-earmark-excel-fill"></i>
                          <span className="ms-2">
                            {loading ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm me-1"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                Exporting...
                              </>
                            ) : (
                              t("export")
                            )}
                          </span>
                        </button>
                        <button
                          type="button"
                          className="btn btn-icon-text mr-2"
                          onClick={sentWasteOpenDetail}
                        >
                          <i className="bi bi-archive"></i>
                          <span className="ms-2">{t("sent_to_waste")}</span>
                        </button>
                        {RolePermission?.findIndex(
                          (e) => e.permission_name === "add_vehicle",
                        ) > -1 && (
                          <button
                            type="button"
                            className="btn  btn-icon-text mr-2"
                            onClick={handleVehicle}
                          >
                            <i className="bi bi-plus-lg"></i>
                            <span className="ms-2">{t("Add")}</span>
                          </button>
                        )}
                        <button
                          type="button"
                          className="btn-icon-text mr-2 mr-2"
                          onClick={handleShowOpen}
                        >
                          <i className="bi bi-funnel"></i>
                          {t("filter")}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="vehicleThBg table-responsive table-responsive-vehicle">
                      <table className="table table-bordered rounded-table table table-striped table-hover">
                        <thead>
                          <tr>
                            {companyId?.role_id === "1" && (
                              <th className="col-form-label ml-2 Label-my form-label form-label">
                                {t("company_name")}
                              </th>
                            )}

                            {columnNames?.map((col, index) => (
                              <th
                                key={index}
                                className="col-form-label ml-2 Label-my form-label form-label"
                              >
                                {tConstStatic((col || "").trim())}
                              </th>
                            ))}

                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ width: "0%" }}
                            >
                              {t("action")}{" "}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoading ? (
                            // ---------- LOADER ----------
                            <tr>
                              <td colSpan={10} className="text-center py-4">
                                <div
                                  className="spinner-border text-primary"
                                  role="status"
                                >
                                  <span className="visually-hidden">
                                    Loading...
                                  </span>
                                </div>
                              </td>
                            </tr>
                          ) : vehicleProcessList?.length === 0 ? (
                            // ---------- NO DATA FOUND ----------
                            <tr>
                              <td colSpan={10} className="text-center py-3">
                                {t("no_record_found")}
                              </td>
                            </tr>
                          ) : (
                            vehicleProcessList?.map((item, index) => (
                              <tr key={index}>
                                {companyId?.role_id === "1" && (
                                  <td>{item.company_name || "-"}</td>
                                )}

                                {columnKeys?.map((key, index) => {
                                  const value = getColumnValue(item, key);
                                  return (
                                    <td
                                      key={index}
                                      className={
                                        key === "vehicle_process_end_date"
                                          ? "force-width"
                                          : ""
                                      }
                                    >
                                      {key === "vehicle_process_end_date" ? (
                                        <span className="btn btn-dangers">
                                          {value}
                                        </span>
                                      ) : (
                                        value
                                      )}
                                    </td>
                                  );
                                })}

                                <td className="d-flex">
                                  <Dropdown
                                    className="iconDropdown"
                                    onToggle={(isOpen) => {
                                      if (isOpen) {
                                        // This logic runs when the dropdown is opened
                                        const tableResponsive =
                                          document.querySelector(
                                            ".table-responsive",
                                          );

                                        if (window.innerWidth <= 767) {
                                          if (tableResponsive) {
                                            tableResponsive.style.overflowX =
                                              "auto !important";
                                            tableResponsive.style.overflowY =
                                              "auto !important";
                                          }
                                        } else {
                                          if (tableResponsive) {
                                            tableResponsive.style.overflowX =
                                              "inherit !important";
                                            tableResponsive.style.overflowY =
                                              "inherit !important";
                                          }
                                        }
                                      }
                                    }}
                                  >
                                    <Dropdown.Toggle
                                      variant="success"
                                      id="dropdown-basic"
                                      className="iconToggle"
                                    >
                                      <i className="bi bi-three-dots-vertical"></i>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                      {params.record_show_type !== 1 && (
                                        <Dropdown.Item
                                          className="d-flex"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            if (item) {
                                              navigate(`/vehicle/${item.id}`, {
                                                state: item,
                                              });
                                            }
                                          }}
                                        >
                                          {RolePermission?.findIndex(
                                            (e) =>
                                              e.permission_name ===
                                              "modify_vehicle",
                                          ) > -1 && (
                                            <button
                                              className="edit-btn"
                                              onClick={(e) =>
                                                e.preventDefault()
                                              }
                                            >
                                              <i className="bi bi-pencil"></i>
                                            </button>
                                          )}
                                          <span>{t("edit")}</span>
                                        </Dropdown.Item>
                                      )}

                                      <Dropdown.Item
                                        href="#/action-2"
                                        className="d-flex"
                                        onClick={(e) =>
                                          onDeleteModalOpen(e, item)
                                        }
                                      >
                                        <div className="trash-btn">
                                          <a
                                            className="delete-btn"
                                            href="#"
                                            onClick={(e) =>
                                              onDeleteModalOpen(e, item)
                                            }
                                          >
                                            <i
                                              className={`bi ${
                                                params.record_show_type === 1
                                                  ? "bi-arrow-clockwise text-danger"
                                                  : "bi-trash3 text-danger"
                                              } fs-5`}
                                            ></i>{" "}
                                          </a>
                                        </div>

                                        <span>
                                          {params.record_show_type === 1
                                            ? t("restore")
                                            : t("delete")}
                                        </span>
                                      </Dropdown.Item>

                                      <Dropdown.Item
                                        className="d-flex"
                                        onClick={(e) =>
                                          onQrDetailsOpen(e, item)
                                        }
                                      >
                                        <button
                                          className="edit-btn"
                                          onClick={(e) => e.preventDefault()}
                                        >
                                          <i className="bi bi-qr-code-scan"></i>
                                        </button>
                                        <span>{t("vehicle_label")}</span>
                                      </Dropdown.Item>

                                      <Dropdown.Item
                                        className="d-flex"
                                        onClick={(e) =>
                                          navigate(
                                            "/parts-inventory/AddParts",
                                            { state: { item } },
                                          )
                                        }
                                      >
                                        <button className="edit-btn">
                                          <i className="bi bi-car-front-fill"></i>
                                        </button>
                                        <span className="ms-2">
                                          {t("dismetal_car")}
                                        </span>
                                      </Dropdown.Item>

                                      <Dropdown.Item
                                        className="d-flex"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          if (item) {
                                            navigate(
                                              `/part-details-vehicle/${item.uuid}`,
                                              {
                                                state: item,
                                              },
                                            );
                                          }
                                        }}
                                      >
                                        <button
                                          className="edit-btn"
                                          onClick={(e) => e.preventDefault()}
                                        >
                                          <img
                                            src={DesmeImage}
                                            style={{ width: "66%" }}
                                          />
                                        </button>
                                        <span>{t("part_details")}</span>
                                      </Dropdown.Item>

                                      <Dropdown.Item
                                        className="d-flex"
                                        onClick={(e) => generatePDF(e, item)}
                                      >
                                        <div className="pdf-btn">
                                          <i className="bi bi-file-earmark-pdf"></i>
                                          {t("download_pdf_report")}{" "}
                                        </div>
                                      </Dropdown.Item>

                                      <Dropdown.Item
                                        className="d-flex"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          if (item) {
                                            navigate(
                                              `/vehicle/details/${item.uuid}`,
                                              {
                                                state: item,
                                              },
                                            );
                                          }
                                        }}
                                      >
                                        <button
                                          className="edit-btn"
                                          onClick={(e) => e.preventDefault()}
                                        >
                                          <i className="bi bi-pencil"></i>
                                        </button>
                                        <span>{t("vehicle_details")}</span>
                                      </Dropdown.Item>

                                      <Dropdown.Item
                                        href="#/action-4"
                                        className="d-flex"
                                        onClick={(e) => {
                                          ontpartHistoryQtyDetailsOpen(e, item);
                                        }}
                                      >
                                        <a className="edit-btn" href="#">
                                          <i className="bi bi-tools"></i>
                                        </a>

                                        <span>{t("vehicle_quantity_history")}</span>
                                      </Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                </div>
              </div>
            </div>
          </div>
          <div className="card-footer clearfix card-footer-part fuelCF">
            <div className="pagination pagination-sm m-0 float-right">
              <ReactPaginate
                previousLabel={<i className="bi bi-chevron-double-left"></i>}
                nextLabel={<i className="bi bi-chevron-double-right"></i>}
                breakLabel={"..."}
                pageCount={Math.ceil(totalRecords / params.limit)}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={(e) => handleParams(e, "pagination")}
                forcePage={params.page - 1}
                containerClassName={"pagination"}
                activeClassName={"active"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
              />
            </div>
          </div>
        </section>

        <Modal isOpen={qrDetails} size="lg">
          <ModalHeader>{t("vehicle_label")}</ModalHeader>
          <ModalBody>
            <div id="tp-vehicle-label-print" className="tp-vlabel">
              <div className="tp-vlabel-header">
                <div className="tp-vlabel-brand">
                  <img
                    src="https://tp.software/libs/assets/images/logo.png"
                    alt="TP Software"
                    style={{ height: 28 }}
                  />
                </div>
                <div className="tp-vlabel-id">
                  <span className="tp-vlabel-id-label">{t("col_vehicle_internal_id")}</span>
                  <span className="tp-vlabel-id-value">
                    {DelPartQRId.vehicle_internal_id || "—"}
                  </span>
                </div>
              </div>

              <div className="tp-vlabel-plate-row">
                <div className="tp-vlabel-plate">
                  <span className="tp-vlabel-plate-flag">🇵🇹</span>
                  <span className="tp-vlabel-plate-text">
                    {DelPartQRId.registration || DelPartQRId.registration_plate || "—"}
                  </span>
                </div>
                {DelPartQRId.vehicle_frame ? (
                  <div className="tp-vlabel-vin">
                    <span className="tp-vlabel-vin-label">VIN</span>
                    <span className="tp-vlabel-vin-value">
                      {DelPartQRId.vehicle_frame}
                    </span>
                  </div>
                ) : null}
              </div>

              <div className="tp-vlabel-grid">
                <div className="tp-vlabel-cell">
                  <span className="tp-vlabel-k">{t("vehicle_make")}</span>
                  <span className="tp-vlabel-v">{DelPartQRId.vehicle_make_name || DelPartQRId.vehicle_brand || "—"}</span>
                </div>
                <div className="tp-vlabel-cell">
                  <span className="tp-vlabel-k">{t("vehicle_model")}</span>
                  <span className="tp-vlabel-v">{DelPartQRId.vehicle_model || "—"}</span>
                </div>
                <div className="tp-vlabel-cell">
                  <span className="tp-vlabel-k">{t("vehicle_year")}</span>
                  <span className="tp-vlabel-v">{DelPartQRId.vehicle_year || "—"}</span>
                </div>
                <div className="tp-vlabel-cell">
                  <span className="tp-vlabel-k">{t("variant")}</span>
                  <span className="tp-vlabel-v">
                    {DelPartQRId.vehicle_variant_name || DelPartQRId.vehicle_variant || "—"}
                  </span>
                </div>
                <div className="tp-vlabel-cell">
                  <span className="tp-vlabel-k">{t("fuel")}</span>
                  <span className="tp-vlabel-v">{DelPartQRId.vehicle_fuel_name || "—"}</span>
                </div>
                <div className="tp-vlabel-cell">
                  <span className="tp-vlabel-k">{t("Ccm3")}</span>
                  <span className="tp-vlabel-v">{DelPartQRId.ccm3 || DelPartQRId.vehicle_cyllinder || "—"}</span>
                </div>
                <div className="tp-vlabel-cell">
                  <span className="tp-vlabel-k">{t("power_Kw")}</span>
                  <span className="tp-vlabel-v">{DelPartQRId.power_kw || "—"}</span>
                </div>
                <div className="tp-vlabel-cell">
                  <span className="tp-vlabel-k">{t("HP")}</span>
                  <span className="tp-vlabel-v">{DelPartQRId.hp || "—"}</span>
                </div>
                <div className="tp-vlabel-cell">
                  <span className="tp-vlabel-k">{t("vehicle_color") || "Color"}</span>
                  <span className="tp-vlabel-v">{DelPartQRId.vehicle_color || "—"}</span>
                </div>
                <div className="tp-vlabel-cell">
                  <span className="tp-vlabel-k">{t("vehicle_kms") || "KMs"}</span>
                  <span className="tp-vlabel-v">{DelPartQRId.vehicle_kms || "—"}</span>
                </div>
                <div className="tp-vlabel-cell">
                  <span className="tp-vlabel-k">{t("col_vehicle_park")}</span>
                  <span className="tp-vlabel-v">{DelPartQRId.vehicle_park || "—"}</span>
                </div>
                <div className="tp-vlabel-cell">
                  <span className="tp-vlabel-k">{t("col_created_at")}</span>
                  <span className="tp-vlabel-v">
                    {DelPartQRId.vehicle_process_start_date
                      ? new Date(DelPartQRId.vehicle_process_start_date).toLocaleDateString()
                      : "—"}
                  </span>
                </div>
              </div>

              <div className="tp-vlabel-barcode">
                <Barcode
                  value={String(DelPartQRId.vehicle_internal_id || DelPartQRId.uuid || "0")}
                  format="CODE128"
                  width={2}
                  height={90}
                  displayValue={true}
                  fontSize={14}
                  margin={0}
                />
              </div>

              <div className="tp-vlabel-footer">
                <span>TP Software</span>
                <span>{new Date().toLocaleDateString()}</span>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleQrDetailsClose}
              style={{ marginTop: "10px" }}
            >
              <i className="bi bi-x-lg"></i> {t("close")}
            </button>
            <button
              type="button"
              className="btn btn-outline-primary"
              onClick={() => {
                const printContents = document.getElementById("tp-vehicle-label-print").innerHTML;
                const w = window.open("", "_blank", "width=900,height=1200");
                w.document.write(`<!DOCTYPE html><html><head><title>${t("vehicle_label")}</title>
                  <style>
                    body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif; margin: 24px; color: #111; }
                    .tp-vlabel { border: 2px solid #111; border-radius: 10px; padding: 24px; background:#fff; }
                    .tp-vlabel-header { display:flex; align-items:center; justify-content:space-between; padding-bottom:14px; border-bottom:2px solid #111; }
                    .tp-vlabel-id-label { display:block; font-size:11px; text-transform:uppercase; letter-spacing:2px; color:#666; }
                    .tp-vlabel-id-value { display:block; font-size:28px; font-weight:800; letter-spacing:1px; color:#111; }
                    .tp-vlabel-plate-row { display:flex; gap:16px; align-items:center; margin:18px 0; }
                    .tp-vlabel-plate { flex:0 0 auto; display:flex; align-items:center; gap:8px; background:#ffd800; color:#111; border:2px solid #111; border-radius:6px; padding:8px 18px; font-family:'Courier New',monospace; font-weight:800; font-size:28px; letter-spacing:2px; }
                    .tp-vlabel-vin { flex:1; font-family:'Courier New',monospace; font-size:14px; color:#444; }
                    .tp-vlabel-vin-label { display:inline-block; font-size:10px; text-transform:uppercase; background:#111; color:#fff; padding:2px 6px; margin-right:8px; border-radius:3px; }
                    .tp-vlabel-grid { display:grid; grid-template-columns: repeat(4, 1fr); gap:8px 12px; margin:18px 0; }
                    .tp-vlabel-cell { border:1px solid #ddd; border-radius:6px; padding:8px 10px; background:#fafafa; }
                    .tp-vlabel-k { display:block; font-size:10px; text-transform:uppercase; letter-spacing:1px; color:#888; }
                    .tp-vlabel-v { display:block; font-size:14px; font-weight:700; color:#111; margin-top:2px; }
                    .tp-vlabel-barcode { display:flex; justify-content:center; padding:20px 0 10px; background:#fff; }
                    .tp-vlabel-footer { display:flex; justify-content:space-between; font-size:10px; color:#888; padding-top:8px; border-top:1px solid #eee; }
                    @page { size: A4; margin: 10mm; }
                  </style></head><body>${printContents}</body></html>`);
                w.document.close();
                w.focus();
                setTimeout(() => { w.print(); }, 400);
              }}
              style={{ marginTop: "10px" }}
            >
              <i className="bi bi-printer"></i> {t("print_browser")}
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleQrDetailsPrint}
              style={{ marginTop: "10px" }}
            >
              <i className="bi bi-printer-fill"></i> {t("send_to_printer")}
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={vehiclePartDetailsModal} size="lg">
          <ModalHeader>{t("part_details")}</ModalHeader>
          <ModalBody>
            <div className="row">
              <div className="col-md-12">
                <div className="vehicleThBg table-responsive">
                  <table className="rounded-table table table-striped table-bordered table-hover">
                    <thead>
                      <tr>
                        <th>{t("part_name")}</th>
                        <th>{t("part_quantity")}</th>
                        <th>{t("part_price")}</th>
                        <th>{t("part_original_price")}</th>
                        <th>{t("part_code")}</th>
                      </tr>
                    </thead>

                    <tbody>
                      {vehiclePartDetails?.length > 0 ? (
                        vehiclePartDetails?.map((item, index) => (
                          <tr key={index}>
                            <td>{item.namePartPT}</td>
                            <td>{item.quantity}</td>
                            <td>€ {item.part_price}</td>
                            <td>€ {item.part_original_price}</td>
                            <td>{item.part_code}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="100%">{t("no_record_found")}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={onvehiclePartDetailsClose}
              style={{ width: "100px", marginTop: "10px" }}
            >
              {t("close")} <i className="bi bi-x-lg"></i>
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={sentWasteModal} size="xl">
          <ModalHeader>
            {t("sent_to_waste")}
            <button
              type="button"
              className="button-Close d-none"
              onClick={sentWasteCloseDetail}
            >
              <i className="bi bi-x-lg"></i>
            </button>
          </ModalHeader>
          <Form method={`post`} onSubmit={handleSubmit}>
            <ModalBody>
              <div className="row">
                <div className="row">
                  <div className="col-md-6">
                    <FormGroup>
                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                        {t("select_ler_catalog")}
                      </Label>
                      <div className="col-xl-13">
                        <div className="input-div">
                          <Select
                            className="my-Select"
                            options={LerCatalogList}
                            value={LerCatalogList.filter((item) =>
                              vehiclePartsData.ler_code_id.includes(item.value),
                            )}
                            onChange={handleSelectLERChange}
                            placeholder={t("select_ler_catalog")}
                            isSearchable={true}
                            onInputChange={handleInputChangeLER}
                            inputValue={inputValueLer}
                            isClearable={true}
                            isMulti
                          />
                        </div>
                      </div>
                    </FormGroup>
                  </div>
                  <div className="col-md-6" style={{ marginTop: "44px" }}>
                    {vehiclePartsData.ler_code_id.length > 0 && (
                      <div className="col-xl-12">
                        <p className="wastage">
                          {t("wastage_value")} : {sumWastageValue}
                        </p>
                      </div>
                    )}
                  </div>

                  <div className="col-md-6">
                    <div className="">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={searchQuery}
                        onChange={handleSearchChange}
                        maxLength={50}
                        placeholder={t("search")}
                      />
                    </div>
                    <div
                      className="vehicleThBg table-responsive tableScroll table-scroll-modal min-height-0"
                      style={{ marginTop: "10px" }}
                    >
                      <table className="rounded-table table table-striped table-bordered table-hover">
                        <thead>
                          <tr>
                            <th style={{ width: "10%" }}>
                              {t("registration")}
                            </th>
                            <th style={{ width: "10%" }}>
                              {t("vehicle_model")}
                            </th>
                            <th style={{ width: "10%" }}>
                              {t("vehicle_year")}
                            </th>
                            <th style={{ width: "0%" }}>{t("action")}</th>
                          </tr>
                        </thead>

                        <tbody>
                          {filteredPartAssignList?.length > 0 ? (
                            filteredPartAssignList?.map((item, index) => (
                              <tr key={index}>
                                <td>{item?.registration}</td>
                                <td>{item.vehicle_model}</td>
                                <td>{item.vehicle_year}</td>
                                <td>
                                  <Button
                                    className="addBtn"
                                    onClick={() =>
                                      handleAddClick(
                                        item.id,
                                        item.registration,
                                        item.vehicle_model,
                                        item.vehicle_year,
                                      )
                                    }
                                    style={{
                                      backgroundColor: addedParts.some(
                                        (part) => part.id === item.id,
                                      )
                                        ? "red"
                                        : "green",
                                      color: "white",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <i className="bi bi-plus-lg"></i>{" "}
                                  </Button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr className="scrollBrdr">
                              <td colSpan="100%">{t("no_record_found")}</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className="card-footer clearfix card-footer-part">
                      <div className="pagination pagination-sm m-0  paginationRight">
                        <Pagination
                          activePage={params.page}
                          itemsCountPerPage={parseInt(params.limit)}
                          totalItemsCount={parseInt(totalRecords)}
                          pageRangeDisplayed={5}
                          itemClass={`page-item`}
                          linkClass={`page-link`}
                          onChange={(e) => handleParams(e, "pagination")}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6" style={{ marginTop: "56px" }}>
                    <div className="vehicleThBg table-responsive tableScroll table-scroll-modal min-height-0">
                      <table className="rounded-table table table-striped table-bordered table-hover">
                        <thead>
                          <tr>
                            <th style={{ width: "10%" }}>
                              {t("registration")}
                            </th>
                            <th style={{ width: "10%" }}>
                              {t("vehicle_model")}
                            </th>
                            <th style={{ width: "10%" }}>
                              {" "}
                              {t("vehicle_year")}
                            </th>

                            <th style={{ width: "0%" }}>{t("action")}</th>
                          </tr>
                        </thead>

                        <tbody>
                          {addedParts?.length > 0 ? (
                            addedParts?.map((item, index) => (
                              <tr key={index}>
                                <td>{item?.registration}</td>
                                <td>{item.vehicle_model}</td>
                                <td>{item.vehicle_year}</td>

                                <td className="">
                                  <button
                                    className="btn-danger-delete"
                                    href="#"
                                    onClick={() =>
                                      handleAddClick(item.id, item.registration)
                                    }
                                  >
                                    <i className="bi bi-trash3"></i>
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr className="scrollBrdr">
                              <td colSpan="100%">{t("no_record_found")}</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <button
                type="button"
                className="btn btn-block btn-primary"
                onClick={sentWasteCloseDetail}
                style={{ width: "100px", marginTop: "10px" }}
              >
                {t("close")} <i className="bi bi-x-lg"></i>
              </button>
              {loading === true ? (
                <button
                  type="submit"
                  className="btn btn-block btn-primary"
                  style={{ width: "100px", marginTop: "10px" }}
                >
                  Loading...
                </button>
              ) : (
                <button
                  type="submit"
                  className="btn btn-block btn-primary"
                  style={{ width: "100px", marginTop: "10px" }}
                >
                  {t("submit")} <i className="bi bi-check2"></i>
                </button>
              )}
            </ModalFooter>
          </Form>
        </Modal>

        <div
          className={`offcanvas offcanvas-end ${show ? "show" : ""}`}
          tabIndex="-1"
          id="staticBackdrop"
          aria-labelledby="staticBackdropLabel"
          style={{ visibility: show ? "visible" : "hidden" }}
        >
          <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="staticBackdropLabel">
              {t("filter")}
            </h5>

            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={handleShowClose}
            ></button>
          </div>

          <div className="offcanvas-body">
            <div>
              <div href="#/action-2">
                <div className="Label-my">
                  {t("part_inventory")}
                  <select
                    className="form-select mt-2 input-search"
                    type="select"
                    value={partInventoryFilter}
                    onChange={(e) => {
                      setpartInventoryFilter(e.target.value);
                    }}
                  >
                    <option>{t("all")}</option>
                    {partInventoryList?.map((item) => (
                      <option key={item.value} value={item.value}>
                        {tConstStatic(item.label)}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div href="#/action-2">
                <div className="Label-my">
                  {t("dismetal")}
                  <select
                    className="form-select mt-2 input-search"
                    type="select"
                    value={dismentalFilter}
                    onChange={(e) => {
                      setDismentalFilter(e.target.value);
                    }}
                  >
                    <option>{t("all")}</option>
                    {dismentalList?.map((item) => (
                      <option key={item.value} value={item.value}>
                        {tConstStatic(item.label)}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div href="#/action-2">
                <div className="Label-my">
                  {t("depollution")}
                  <select
                    className="form-select mt-2 input-search"
                    type="select"
                    value={depollutionFilter}
                    onChange={(e) => {
                      setdepollutionFilter(e.target.value);
                    }}
                  >
                    <option>{t("all")}</option>
                    {depollutionList?.map((item) => (
                      <option key={item.value} value={item.value}>
                        {tConstStatic(item.label)}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div href="#/action-2">
                <div className="Label-my">
                  {t("state_parking")}
                  <select
                    className="form-select mt-2 input-search"
                    type="select"
                    value={stateParkingFilter}
                    onChange={(e) => {
                      setStateParkingFilter(e.target.value);
                    }}
                  >
                    <option>{t("all")}</option>
                    {stateParkingList?.map((item) => (
                      <option key={item.value} value={item.value}>
                        {tConstStatic(item.label)}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div>
                <div className="Label-my">
                  {t("registration_no")}{" "}
                  <input
                    className="form-control mt-2 input-search"
                    type="text"
                    value={registration}
                    onChange={(e) => {
                      setRegistration(e.target.value);
                    }}
                    maxLength={50}
                    placeholder={t("registration_no")}
                  />
                </div>
              </div>

              <div>
                <div className="Label-my">
                  {t("year")}
                  <input
                    className="form-control mt-2 input-search"
                    type="text"
                    value={year}
                    onChange={(e) => {
                      SetYear(e.target.value);
                    }}
                    maxLength={50}
                    placeholder={t("year")}
                    onClick={(e) => e.stopPropagation()}
                  />
                </div>
              </div>

              <div>
                <div className="Label-my">
                  {t("make")}
                  <input
                    className="form-control mt-2 input-search"
                    type="text"
                    value={make}
                    onChange={(e) => {
                      SetMake(e.target.value);
                    }}
                    maxLength={50}
                    placeholder={t("make")}
                    onClick={(e) => e.stopPropagation()}
                  />
                </div>
              </div>
              <div>
                <div className="Label-my">
                  {t("modal")}

                  <input
                    className="form-control mt-2 input-search"
                    type="text"
                    value={model}
                    onChange={(e) => {
                      setModel(e.target.value);
                    }}
                    maxLength={50}
                    placeholder={t("model")}
                    onClick={(e) => e.stopPropagation()}
                  />
                </div>
              </div>
              <div>
                <div className="Label-my">
                  {t("variant")}

                  <input
                    className="form-control mt-2 input-search"
                    type="text"
                    value={variant}
                    onChange={(e) => {
                      SetVariant(e.target.value);
                    }}
                    maxLength={50}
                    placeholder={t("variant")}
                    onClick={(e) => e.stopPropagation()}
                  />
                </div>
              </div>

              <div>
                <div className="Label-my">
                  {t("Internal Id")}{" "}
                  <input
                    className="form-control mt-2 input-search"
                    type="number"
                    value={internalId}
                    onChange={(e) => {
                      SetInternalId(e.target.value);
                    }}
                    maxLength={50}
                    placeholder={t("internal_id")}
                    onClick={(e) => e.stopPropagation()}
                  />
                </div>
              </div>

              <div href="#/action-2">
                <div className="Label-my">
                  {t("restore_data")}
                  <select
                    className="form-select mt-2 input-search"
                    value={recordStatus}
                    onChange={(e) => setRecordStatus(e.target.value)}
                  >
                    {vehicleDeletedList.map((item) => (
                      <option key={item.id} value={item.id}>
                        {t(item.valueKey)}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div href="#/action-2">
                <div className="Label-my">
                  {t("partsCatalog")}

                  <Select
                    className="my-select-v mt-2"
                    options={catelogList}
                    value={
                      catelogList.find(
                        (item) => item.value === PartCatalogFilter.catalog_name,
                      ) || null
                    }
                    onChange={(selectedOption) => {
                      setPartCatalogFilter((prev) => ({
                        ...prev,
                        catalog_name: selectedOption
                          ? selectedOption.value
                          : "",
                      }));
                    }}
                    placeholder={t("select_part_name")}
                    isClearable={true}
                    inputValue={inputSelectedCatelog}
                    onInputChange={(inputValue) => {
                      setInputSelectedCatelog(inputValue);
                      handleInputSelectedChangeCatelogList(inputValue);
                    }}
                  />
                </div>
              </div>

              <div href="#/action-2">
                <div className="Label-my">
                  {t("parts_check_status")}
                  <select
                    className="form-select mt-2 input-search"
                    type="select"
                    value={partCheckStatusFilter}
                    onChange={(e) => {
                      setPartCheckStatusFilter(e.target.value);
                    }}
                  >
                    <option value="">{t("all")}</option>
                    {partCheckStatusList?.map((item) => (
                      <option key={item.value} value={item.value}>
                        {tConstStatic(item.label)}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div href="#/action-2">
                <div className="Label-my">
                  {t("parts_check_converted_status")}
                  <select
                    className="form-select mt-2 input-search"
                    type="select"
                    value={convertedStatusFilter}
                    onChange={(e) => {
                      setConvertedStatusFilter(e.target.value);
                    }}
                  >
                    <option value="">{t("all")}</option>
                    {convertedStatusList?.map((item) => (
                      <option key={item.value} value={item.value}>
                        {tConstStatic(item.label)}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-around mb-3">
              <button
                style={{ marginTop: "9px", display: "flex" }}
                type="button"
                className="btn  btn-primary btn-filter"
                onClick={(e) => handleParams(e, "search")}
              >
                <span className="ms-1"> {t("filter")}</span>
              </button>
              <button
                style={{ marginTop: "9px", display: "flex" }}
                type="button"
                className="btn  btn-primary ms-1 btn-filter"
                onClick={ResetModal}
              >
                <span className="ms-1 "> {t("reset")}</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <Modal isOpen={delModal}>
        <ModalHeader>
          {params.record_show_type === 1 ? t("restore_vehicle") : t("delete_vehicle")}
        </ModalHeader>
        <ModalBody>
          <p className={`mb-0`}>
            {params.record_show_type === 1
              ? t("confirm_restore_vehicle")
              : t("confirm_delete_vehicle")}
          </p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={isDelButtonLoad}
            onClick={onDeleteModalClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("close")} <i className="bi bi-x-lg"></i>
          </button>

          {!isDelButtonLoad && params.record_show_type === 1 ? (
            <>
              <button
                type="button"
                className="btn btn-block bg-red"
                style={{ width: "100px" }}
                onClick={onDestroyPartInventory}
              >
                {t("restore")} <i className="bi bi-arrow-repeat"></i>
              </button>
            </>
          ) : (
            <>
              <button
                type="button"
                className="btn btn-block bg-red"
                style={{ width: "100px" }}
                onClick={onDestroyPartInventory}
              >
                {t("delete")} <i className="bi bi-trash3"></i>
              </button>
            </>
          )}

          {isDelButtonLoad && (
            <button
              color="secondary"
              type={`button`}
              disabled={true}
              className={`btn-square`}
            >
              <i className="fa fa-circle-o-notch fa-spin"></i> {`Loading...`}
            </button>
          )}
        </ModalFooter>
      </Modal>

      <Modal isOpen={partHistoryQtyModal} size="lg">
        <ModalHeader>
          {`Vehicle History Details`}
          <button
            type="button"
            className="button-Close d-none"
            onClick={onpartHistoryQtyDetailsClose}
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="vehicleThBg table-responsive mt-2">
              <table className="rounded-table table table-striped table-bordered table-hover">
                <thead>
                  <tr>
                    <th>{t("date")}</th>
                    <th>{t("user_name")}</th>
                    <th>{t("log")}</th>
                  </tr>
                </thead>

                <tbody>
                  {partInventoryHistoryList?.length > 0 ? (
                    partInventoryHistoryList.map((item, index) => (
                      <tr key={index}>
                        <td>
                          {moment(item.created_at).format(
                            "DD/MM/YYYY HH:mm:ss",
                          )}{" "}
                        </td>
                        <td>{item.user_name}</td>
                        <td>
                          <MessageCell message={item.message} />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center text-muted">
                        No vehicle history available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="card-footer clearfix card-footer-part">
              <div className="pagination pagination-sm m-0  paginationRight">
                <ReactPaginate
                  previousLabel={<i className="bi bi-chevron-double-left"></i>}
                  nextLabel={<i className="bi bi-chevron-double-right"></i>}
                  breakLabel={"..."}
                  pageCount={Math.ceil(totalPartInven / partLimit)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={(e) => setPartPage(e.selected + 1)} // 0-based index
                  forcePage={partPage - 1} // keep UI synced
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                />
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={onpartHistoryQtyDetailsClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            Close <i className="bi bi-x-lg"></i>
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default VehicleProcess;
